import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "latitude",
    "locationStatus",
    "longitude",
    "manualInput",
    "placeholder",
    "preview",
    "submit"
  ]

  static values = {
    locationAddedText: String,
    locationErrorText: String,
    locationLoadingText: String,
    locationUnavailableText: String,
    scanLoadingText: String
  }

  connect() {
    this.submitStartHandler = () => this.disableSubmit()
    this.submitEndHandler = () => this.enableSubmit()

    this.element.addEventListener("turbo:submit-start", this.submitStartHandler)
    this.element.addEventListener("turbo:submit-end", this.submitEndHandler)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.submitStartHandler)
    this.element.removeEventListener("turbo:submit-end", this.submitEndHandler)
  }

  disableSubmit() {
    if (!this.hasSubmitTarget) return

    this.submitTarget.dataset.originalValue ||= this.submitTarget.value
    this.submitTarget.disabled = true
    this.submitTarget.value = this.scanLoadingTextValue
    this.submitTarget.classList.add("cursor-wait", "opacity-70")
  }

  enableSubmit() {
    if (!this.hasSubmitTarget) return

    this.submitTarget.disabled = false
    this.submitTarget.value = this.submitTarget.dataset.originalValue
    this.submitTarget.classList.remove("cursor-wait", "opacity-70")
  }

  previewImage(event) {
    const [file] = event.target.files
    if (!file) return

    this.previewTarget.src = URL.createObjectURL(file)
    this.previewTarget.classList.remove("hidden")
    this.placeholderTarget.classList.add("hidden")
  }

  toggleManualInput(event) {
    event.preventDefault()
    this.manualInputTarget.classList.toggle("hidden")
  }

  useLocation(event) {
    event.preventDefault()

    if (!navigator.geolocation) {
      this.showLocationStatus(this.locationUnavailableTextValue)
      return
    }

    this.showLocationStatus(this.locationLoadingTextValue)
    navigator.geolocation.getCurrentPosition(
      (position) => this.setLocation(position),
      () => this.showLocationStatus(this.locationErrorTextValue)
    )
  }

  setLocation(position) {
    this.latitudeTarget.value = position.coords.latitude
    this.longitudeTarget.value = position.coords.longitude
    this.showLocationStatus(this.locationAddedTextValue)
  }

  showLocationStatus(message) {
    this.locationStatusTarget.textContent = message
    this.locationStatusTarget.classList.remove("hidden")
  }
}
